import React, { Component } from 'react';

import TeamMember from './team-member';
import Lu from './images/lu.jpg';
import Alex from './images/alex.jpg';

const founders = [
  {
    name: 'Luis Martinez',
    position: 'Founder, Product',
    image: Lu,
    quote: (
      <div>
        <p>
          While in law school, I was a Fellow for Children's Rights. I've been
          involved in youth development ever since - in and out of schools. From
          experiences that range corporate life to teaching in classrooms, it
          became clear to me a child's future success, especially in our current
          world, depends on developing key skills not effectively or
          consistently emphasized.
        </p>
        <p>
          I believe every child should have access to methods to perform great
          academically, yet also be enriched with chances to develop real world
          skills they'll use to thrive in a world that's changing faster than
          ever. With Unyted, we can do this at the same time!
        </p>
      </div>
    ),
  },
  {
    name: 'Alex Wynter',
    position: 'Co-Founder, CTO',
    image: Alex,
    quote: (
      <div>
        <p>
          Since I was a child, I was blessed with mentors and guardians that
          sought to feed my natural curiosity. I learned to love learning, even
          through the trials and tribulations of a poor, rural public school. I
          learned that the ways we teach and learn leave much room for
          improvement.
        </p>
        <p>
          After years of working in education technology, I found Unyted. I had
          seen these important intrapersonal and interpersonal skills backfire
          in professional settings, brilliant people hindered by their lack of
          self-awareness or communication skills. These skills could be coached
          and engaged at the same time as academic learning, in a classrom
          setting.
        </p>
        <p>
          Students can learn to work on teams, communicate effectively, and
          still respect one another, all while being more engaged with the
          material. This was the improvement I had been searching for. I've
          always wanted my efforts to positively improve the world, and I feel
          like Unyted, both the platform and the method, will continually
          improve how we educate future generations.
        </p>
      </div>
    ),
  },
];

export default class TeamMembers extends Component {
  render() {
    return (
      <div className="d-flex flex-row justify-content-center flex-wrap mt-3">
        {founders.map(founder => (
          <TeamMember {...founder} />
        ))}
      </div>
    );
  }
}
